export const ASSIGNABLE_USER_ROLES = ["USER", "CREATOR", "ADMIN", "TUTOR", "MANAGER"];

function normalizeRoleName(value) {
    return String(value || "").trim().toUpperCase();
}

export function sortUserRoles(roles) {
    const set = new Set((roles || []).map(normalizeRoleName).filter(Boolean));
    return ASSIGNABLE_USER_ROLES.filter((role) => set.has(role));
}

export function withBaseUserRole(roles) {
    const next = sortUserRoles(roles);
    if (!next.includes("USER")) {
        next.unshift("USER");
    }
    return next;
}

export function resolveUserRoles(user) {
    const fromList = Array.isArray(user?.userRoles) ? user.userRoles : [];
    const fromDetails = Array.isArray(user?.details?.roles) ? user.details.roles : [];
    const primary = user?.userRole ? [user.userRole] : [];
    return withBaseUserRole([...primary, ...fromList, ...fromDetails]);
}

export function formatUserRoles(roles) {
    const list = sortUserRoles(roles);
    return (list.length ? list : ["USER"]).join(", ");
}

export function rolesEqual(a, b) {
    const left = formatUserRoles(a);
    const right = formatUserRoles(b);
    return left === right;
}

export function hasUserRole(user, role) {
    const target = String(role || "").trim().toUpperCase();
    if (!target) {
        return false;
    }
    return resolveUserRoles(user).includes(target);
}
